// extracted by mini-css-extract-plugin
export default {"icon-close":"icon-close","iconClose":"icon-close"};